import { faFileExport } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import moment from "moment";
import React from "react";
import { withRouter } from "react-router-dom";
import ReactTable from "react-table";
import { Button, Col, Container, Row } from "reactstrap";
import BaseInput from "../../../toolkit/baseInput";
import constants from "../../../utils/constants";
import { handleRequestError } from "../../../utils/helpers";
import { infoNotification } from "../../../utils/notifications";
import {
  getConciliacionData,
  getConciliacionFacturasMetadataData,
  getConciliacionReporteFinanzasCruce
} from "../../actions/billing";
import { getClubsRequest } from "../../actions/catalogs";
import MexicanCurrency from "../common/currency";
import DatePicker from "../common/DatePicker";
import s from "./styles.scss";

interface Props {
  history: any;
  match: any;
}

interface State {
  fecha: String;
  clubId: String;
  data: object;
  saving: boolean;
  loading: boolean;
  loadingReporteGeneral: boolean;
  clubsCatalog: any[];
  storageFileId: String;
}

class ConciliacionFacturas extends React.Component<Props, State> {
  state = {
    clubsCatalog: [],
    fecha: null,
    clubId: null,
    data: null,
    saving: false,
    loading: false,
    loadingReporteGeneral: false,
    storageFileId: null
  };

  componentDidMount() {
    this.getClubsCatalog();
  }

  getClubsCatalog = () => {
    getClubsRequest()
      .then(({ data }) => {
        this.setState({ clubsCatalog: data });
      })
      .catch(handleRequestError);
  };

  handleSearch = () => {
    const { fecha, clubId } = this.state;

    this.setState({ loading: true });

    infoNotification("Consultando datos...");

    getConciliacionFacturasMetadataData(0, fecha)
      .then(({ data }) => {
        this.setState({
          loading: false,
          data,
          storageFileId: data.storageFileId || 0
        });
      })
      .catch(err => {
        handleRequestError(err);
        this.setState({ loading: false, saving: false });
      });
  };

  handleReporteGeneral = () => {
    const { fecha } = this.state;

    this.setState({ loadingReporteGeneral: true });

    infoNotification("Consultando reporte general de conciliación");

    getConciliacionReporteFinanzasCruce(fecha)
      .then(({ data }) => {
        this.setState({
          loadingReporteGeneral: false
        });

        if (!!data) {
          const url = `${constants.BASE_URL}/${constants.DOCUMENTS_BASE_URL}/${data}`;
          window.open(url, "_blank");
        }
      })
      .catch(err => {
        handleRequestError(err);
        this.setState({ loadingReporteGeneral: false });
      });
  };

  clearFields = () => {
    this.setState({
      fecha: null,
      data: null,
      saving: false,
      loading: false,
      storageFileId: null
    });
  };

  columns = [
    {
      Header: "Concepto",
      accessor: "descripcion",
      className: "text-wrap"
    },
    {
      Header: "#",
      accessor: "valor",
      className: "text-center"
    },
    {
      Header: "Importe",
      className: "text-right",
      Cell: row => {
        return <MexicanCurrency quantity={row.original.importe} />;
      }
    }
  ];

  render() {
    const { data, fecha } = this.state;

    return (
      <Container className="w-100 px-0 pt-2">
        {/* <Row className="primaryTitle m-0 mb-2 mt-4">
          <Col xs="12">
            <p className="m-0">Consultar</p>
          </Col>
        </Row> */}

        <Row>
          {/*  <Col xs={3} className="pr-0 pt-2">
            <BaseInput
              label={"Club:"}
              id="extConfigClubFact"
              name="extConfigClubFact"
              type="select"
              value={this.state.clubId}
              options={(this.state.clubsCatalog || []).map(x => {
                return { value: x.clubId, label: x.nombre };
              })}
              onChange={(e) => {
                this.setState({ clubId: e.target.value })
              }}
            />
          </Col> */}
          <Col xs={3} className="pr-0 pt-2">
            <DatePicker
              label="Fecha"
              name="fechaInicioVigencia"
              id="fechaInicioVigencia"
              selected={this.state.fecha}
              onChange={e => {
                const date = moment(e).format("YYYY-MM-DD");
                this.setState({ fecha: date });
              }}
              errors={[]}
            />
          </Col>
          <Col xs={2} className="mt-4 pr-0 pt-2">
            <Button
              className={`${s.buttonMarginTop} ${s.primaryButton} mr-5`}
              onClick={() => {
                this.handleSearch();
              }}
              size="sm"
              block
              disabled={this.state.loading}
            >
              Consultar
            </Button>
          </Col>

          <Col xs={2} className="mt-4 pr-0 pt-2">
            <Button
              className={`${s.buttonMarginTop} ${s.primaryButton} mr-5`}
              onClick={() => {
                this.handleReporteGeneral();
              }}
              size="sm"
              block
              disabled={this.state.loadingReporteGeneral}
            >
              Descargar detalle de conciliación
            </Button>
          </Col>
        </Row>

        {/* ------------------------------------------------------- */}
        {!!data && (
          <div>
            <Row className="primaryTitle m-0 mb-4 mt-4">
              <Col xs="10">
                <p className="m-0">Metadata - {fecha}</p>
              </Col>
            </Row>
            <Row>
              <Col xs={2}></Col>
              <Col xs={8}>
                <div>
                  {!!data.storageFileId && (
                    <div className={"mt-5 mb-5 text-right"}>
                      <span>Ver archivo de equivalencias: </span>
                      <Button
                        id="btnReportExportCsv"
                        color="link"
                        onClick={() => {
                          const url = `${constants.BASE_URL}/${constants.DOCUMENTS_BASE_URL}/${this.state.storageFileId}`;
                          window.open(url, "_blank");
                        }}
                      >
                        <FontAwesomeIcon icon={faFileExport} color="black" />
                      </Button>
                    </div>
                  )}

                  <ReactTable
                    data={data.metadata || []}
                    columns={[
                      {
                        Header: "Concepto",
                        accessor: "descripcion",
                        className: "text-wrap"
                      },
                      {
                        Header: "#",
                        accessor: "valor",
                        className: "text-right"
                      },
                      {
                        Header: "Suma importes",
                        className: "text-right",
                        Cell: row => {
                          return (
                            <MexicanCurrency quantity={row.original.importe} />
                          );
                        }
                      }
                    ]}
                    className="-striped -highlight"
                    sortable={false}
                    showPagination={false}
                    pageSize={(data.metadata || []).length + 2}
                    loading={this.state.loading}
                  />
                </div>
              </Col>
              <Col xs={2}></Col>
            </Row>
          </div>
        )}

        {!!data && (
          <div>
            <Row className="primaryTitle m-0 mb-4 mt-4">
              <Col xs="10">
                <p className="m-0">Facturas - {fecha}</p>
              </Col>
            </Row>
            <Row>
              <Col xs={2}></Col>
              <Col xs={8}>
                <div>
                  <ReactTable
                    data={data.facturas || []}
                    columns={[
                      {
                        Header: "Concepto",
                        accessor: "descripcion",
                        className: "text-wrap"
                      },
                      {
                        Header: "#",
                        accessor: "valor",
                        className: "text-right"
                      },
                      {
                        Header: "Suma importes",
                        className: "text-right",
                        Cell: row => {
                          return (
                            <MexicanCurrency quantity={row.original.importe} />
                          );
                        }
                      }
                    ]}
                    className="-striped -highlight"
                    sortable={false}
                    showPagination={false}
                    pageSize={(data.facturas || []).length + 2}
                    loading={this.state.loading}
                  />
                </div>
              </Col>
              <Col xs={2}></Col>
            </Row>
          </div>
        )}
      </Container>
    );
  }
}

export default withRouter(withStyles(s)(ConciliacionFacturas));
